import { render, staticRenderFns } from "./PerformanceAndEndurance.vue?vue&type=template&id=7651ad4b&scoped=true"
import script from "./PerformanceAndEndurance.vue?vue&type=script&lang=js"
export * from "./PerformanceAndEndurance.vue?vue&type=script&lang=js"
import style0 from "./PerformanceAndEndurance.vue?vue&type=style&index=0&id=7651ad4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7651ad4b",
  null
  
)

export default component.exports